// src/components/IjrrGear/IjrrGearProductGrid.js

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import slugify from 'slugify';

export default function IjrrGearProductGrid({ products, onToggleSidebar }) {
    return (
        <div className="col-xl-10">
            <div className="row">
                <div className="col-12 mobile-only-filter-toggle">
                    <div className="card mb-20">
                        <div className="card-body">
                            <div className="grid-wrap-header">
                                <div>
                                    <button
                                        className="btn btn-outline-primary filter-toggle mr-10"
                                        onClick={onToggleSidebar}
                                    >
                                        <i className="fa fa-filter" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {products.length === 0 ? (
                    <div className="col-12">
                        <p>No products found.</p>
                    </div>
                ) : (
                    products.map(product => (
                        <ProductCard key={product.model_id} product={product} />
                    ))
                )}
            </div>
        </div>
    );
}

function ProductCard({ product }) {
    const [hoverImage, setHoverImage] = useState(null);
    const [isHovered, setIsHovered] = useState(false);
    const navigate = useNavigate();

    const handleMouseEnter = (thumbnailUrl) => {
        const fullImageUrl = thumbnailUrl.replace('/thumbs', '');
        setHoverImage(fullImageUrl);
    };

    const handleMouseLeave = () => {
        setHoverImage(null);
    };

    const handleGoToDetail = (colorIndex = 0) => {
        const slug = slugify(product.name, { lower: true, strict: true });
        navigate(`/ijrr-gear/${product.model_id}/${slug}/${colorIndex}`);
    };

    return (
        <div
            className="col-md-4 col-6"
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            <div
                className="product-boxwrap"
                onClick={() => handleGoToDetail(0)}
                style={{ cursor: 'pointer' }}
            >
                <div className="product-imgwrap">
                    <div className="ijrr-product-image-container">
                        <img src={hoverImage || product.image} alt={product.name} />
                    </div>
                    
                    {product.is_promoted && (
                        // FIX 1: Changed 'class' to 'className'
                        <span className="product-promoted-label" title="Promoted"> 
                            <img src="/assets/images/ijrr/flame.png" alt="Promoted" />
                            {/* FIX 2: Changed 'class' to 'className' */}
                            <span className="promoted-text">BESTSELLER</span> 
                        </span>
                    )}
                    
                    <span className="product-discount-label">{product.categoryName}</span>
                </div>
                <div className="product-detailwrap">
                    <div>
                        {product.inventories && (
                            <>
                                <div
                                    className={`product-colors ${isHovered ? 'visible' : 'hidden'}`}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    {product.inventories.map((variant, index) => (
                                        <span
                                            key={index}
                                            className={`product-color-circle ${index === 0 ? 'active' : ''}`}
                                            style={{ backgroundImage: `url(${variant.thumbnail})` }}
                                            onMouseEnter={() => handleMouseEnter(variant.thumbnail)}
                                            onMouseLeave={handleMouseLeave}
                                            onClick={() => handleGoToDetail(index)}
                                        ></span>
                                    ))}
                                </div>
                                <div className={`product-colors-count ${isHovered ? 'hidden' : 'visible'}`}>
                                    {product.inventories.length} Colors available
                                </div>
                            </>
                        )}
                        <h5>{product.name}</h5>
                        <p>{product.subcategory?.name}</p>
                        <div className="pro-price">${product.price}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}